// **React Imports
import React, { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

// **Component Imports
import OverlayLoading from '../components/overlay-loading'
import ErrorBoundary from '../pages/error'

// **Utils Imports
import { ROLES } from '../utils/constant'
import { getJWTToken, getUserDetails, removeJWTToken } from '../utils/utils'

const RestrictedRoute = () => {
  //variables
  const jwt = getJWTToken()
  const userDetails = getUserDetails()

  if (jwt && userDetails) {
    if (userDetails?.roles?.toLowerCase() === ROLES.CANDIDATE) {
      removeJWTToken()
      return (
        <ErrorBoundary>
          <Suspense fallback={<OverlayLoading />}>
            <Outlet />
          </Suspense>
        </ErrorBoundary>
      )
    } else {
      return <Navigate to="/" replace />
    }
  } else {
    return (
      <ErrorBoundary>
        <Suspense fallback={<OverlayLoading />}>
          <Outlet />
        </Suspense>
      </ErrorBoundary>
    )
  }
}

export default RestrictedRoute
